const els = {
    $content: () => $('[data-page-content]'),
    $contentSection: () => els.$content().find('.content').first(),
    $firstContentSectionChild: () => els.$contentSection().children().first(),
};

export default {
    els,
};

